import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { BsChevronDown } from 'react-icons/bs';
import cStyles from './Dropdown.module.css';

const VacantestDropdown = ({
  option, setOption, options, stoped,
}) => {
  const [isActive, setIsActive] = useState(false);

  const handleItem = (item) => {
    setOption(item);
    setIsActive(false);
  };

  return (
    <div className={cStyles.dropdown}>
      <button
        type="button"
        className={cStyles.dropdown__button}
        onClick={() => setIsActive(!isActive)}
        disabled={stoped}
      >
        <p>{option.name}</p>
        <div className={cStyles.dropdown__icon}>
          <BsChevronDown size={20} />
        </div>
      </button>
      {isActive && (
        <div className={cStyles.dropdown__content}>
          {options.map((item) => (
            <button
              type="button"
              className={cStyles.dropdown__item}
              onClick={() => handleItem(item)}
              key={item.id}
              disabled={stoped || false}

            >
              {item.displayName || item.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default VacantestDropdown;

VacantestDropdown.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({}),
  ),
  option: PropTypes.oneOfType([
    PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.number,
    }),
    PropTypes.string,
  ]),
  setOption: PropTypes.func,
  stoped: PropTypes.bool,
};

VacantestDropdown.defaultProps = {
  option: { name: 'Error', id: 0 },
  setOption: () => 1,
  options: [{ name: 'Error' }],
  stoped: false,

};
